import Widgets from 'js-widget-hooks';
import '../../../../src/Resources/core/jsx/components/widgets';
import './widgets/glossary';
import './widgets/map';
import './widgets/teacher';
import './widgets/search'; // should this be part of the core?
import './widgets/imagezoom';
import './widgets/ajax-send';
import './widgets/timeline';
import './widgets/refuge-tree';
import './widgets/user';

// Konditionales Laden des simple_lazy_loading Scripts
// Lädt NUR auf Hauptseite und Timeline-Seiten

// Prüfe ob wir auf der Hauptseite oder Timeline-Seite sind
const currentPath = window.location.pathname;
const isHomePage = currentPath === '/' || currentPath === '';
const isTimelinePage = currentPath.startsWith('/timeline/') ||
  currentPath === '/timeline';

// Lade das Script nur wenn wir auf der Hauptseite oder Timeline-Seite sind
if (isHomePage || isTimelinePage) {
  import('./lib/simple_lazy_loading')
    .then(() => {
      console.log('Simple lazy loading loaded for:', currentPath);
    })
    .catch((error) => {
      console.error('Error loading simple lazy loading:', error);
    });
} else {
  console.log('Simple lazy loading skipped for:', currentPath);
}

// initialize all the widgets
Widgets.init();
